"use client";

import { CategoryFaq } from '@/services/dataTypes';
import React, { useState } from 'react';

interface Props {
    faq: CategoryFaq;
    index: number;
}

const CategoryFaqsAccordion = ({ faq, index }: Props) => {
    const [open, setOpen] = useState(index === 0);

    return (
        <div
            className="rounded-xl overflow-hidden transition-all duration-200"
            style={{
                border: open ? '1px solid #B7DFC9' : '1px solid #F1F5F9',
                background: open ? '#F7FBF9' : '#FFFFFF',
            }}
        >
            {/* Question row */}
            <button
                onClick={() => setOpen(o => !o)}
                className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left transition-colors duration-200"
                aria-expanded={open}
            >
                <span
                    className="text-[13px] font-semibold leading-snug"
                    style={{ color: open ? '#5D27A1' : '#1E293B' }}
                >
                    {faq.question}
                </span>
                <span
                    className="flex-shrink-0 w-6 h-6 rounded-lg flex items-center justify-center transition-colors duration-200"
                    style={{
                        background: open ? '#5D27A1' : '#F1F5F9',
                        color: open ? '#FFFFFF' : '#94A3B8',
                    }}
                >
                    <svg
                        className={`w-3.5 h-3.5 transition-transform duration-300 ${open ? 'rotate-180' : ''}`}
                        fill="none" stroke="currentColor" viewBox="0 0 24 24"
                    >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M19 9l-7 7-7-7" />
                    </svg>
                </span>
            </button>

            {/* Answer */}
            {open && (
                <div
                    className="px-5 pb-5 text-[13px] leading-relaxed"
                    style={{ color: '#64748B', borderTop: '1px solid #E8F5EE' }}
                >
                    <p className="m-0 pt-4">{faq.answer}</p>
                </div>
            )}
        </div>
    );
};

export default CategoryFaqsAccordion;
